import { combineReducers } from 'redux';
import moduleReducer from './module';

const reducer = combineReducers({
module: moduleReducer
});

export default reducer;
